(function () {
  'use strict';

  // ============================================================
  // Helpers
  // ============================================================

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var euros = cents / 100;
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(euros);
    } catch (e) {
      return '€' + euros.toFixed(2).replace('.', ',');
    }
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var ctx = this, args = arguments;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getCartMode() {
    return document.body.getAttribute('data-cart-mode') || 'b2c_drawer';
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function updateCartItem(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  // Cross-sell config — match product op theme-settings tag-regel (window.adeqoCrossSell).
  // Theme settings regel: { match_tag, mode: 'fixed'|'per_panels', qty, unit_singular, unit_plural }
  function parseCrossSellConfig(product) {
    if (!product || !window.adeqoCrossSell || !window.adeqoCrossSell.length) return null;
    var tags = typeof product.tags === 'string'
      ? product.tags.split(',').map(function (t) { return t.trim().toLowerCase(); })
      : (product.tags || []).map(function (t) { return String(t).toLowerCase(); });

    for (var i = 0; i < window.adeqoCrossSell.length; i++) {
      var rule = window.adeqoCrossSell[i];
      if (!rule || !rule.match_tag) continue;
      if (tags.indexOf(String(rule.match_tag).toLowerCase()) === -1) continue;
      var unit = rule.unit_singular || 'stuks';
      var unitPlural = rule.unit_plural || (unit + 's');
      return {
        fixed_qty: rule.mode === 'fixed' ? (parseInt(rule.qty, 10) || 0) : 0,
        panels_per_unit: rule.mode === 'per_panels' ? (parseInt(rule.qty, 10) || 0) : 0,
        unit: unit,
        unit_plural: unitPlural,
        doel: 'panelen'
      };
    }
    return null;
  }
  // Backwards-compat alias (oude naam wordt elders nog gebruikt)
  var parseCrossSellTags = parseCrossSellConfig;

  // Bouwt subtitle + aanbevolen quantity.
  // Fixed-qty: "<strong>2 eindlatten aanbevolen</strong>" (geen panelen-deling)
  // Proportioneel: "1 tube per 2 panelen · <strong>2 tubes aanbevolen</strong>"
  function buildCrossSellSubtitle(conf, cartQty) {
    if (conf.fixed_qty && conf.fixed_qty > 0) {
      var unitLabelFixed = conf.fixed_qty === 1 ? conf.unit : conf.unit_plural;
      return {
        text: '<strong>' + conf.fixed_qty + ' ' + unitLabelFixed + ' aanbevolen</strong>',
        quantity: conf.fixed_qty
      };
    }
    var aanbevolen = Math.max(1, Math.ceil(cartQty / conf.panels_per_unit));
    var unitLabel = aanbevolen === 1 ? conf.unit : conf.unit_plural;
    return {
      text: '1 ' + conf.unit + ' per ' + conf.panels_per_unit + ' ' + conf.doel +
            ' · <strong>' + aanbevolen + ' ' + unitLabel + ' aanbevolen</strong>',
      quantity: aanbevolen
    };
  }

  function pulseCartIcon() {
    var icons = document.querySelectorAll('.btn-smallcart');
    icons.forEach(function (el) {
      el.classList.remove('adeqo-cart-pulse');
      // force reflow
      void el.offsetWidth;
      el.classList.add('adeqo-cart-pulse');
    });
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.cart-count p').forEach(function (el) {
      el.textContent = count;
    });
  }

  // Inject pulse-animation styles eenmalig
  function injectPulseStyles() {
    if (document.getElementById('adeqo-cart-pulse-style')) return;
    var s = document.createElement('style');
    s.id = 'adeqo-cart-pulse-style';
    s.textContent =
      '@keyframes adeqoCartPulse{0%{transform:scale(1)}50%{transform:scale(1.15)}100%{transform:scale(1)}}' +
      '.adeqo-cart-pulse{animation:adeqoCartPulse .3s ease}';
    document.head.appendChild(s);
  }

  // ============================================================
  // Cart Drawer (B2C)
  // ============================================================

  if (!customElements.get('godu-cart-drawer')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.cfg = {
          goduThresholdCents: parseInt(this.dataset.goduThresholdCents, 10) || 9800,
          goduCostCents: parseInt(this.dataset.goduCostCents, 10) || 595,
          adezzThresholdCents: parseInt(this.dataset.adezzThresholdCents, 10) || 54500,
          adezzCostCents: parseInt(this.dataset.adezzCostCents, 10) || 4000,
          adezzVendor: this.dataset.adezzVendor || 'Adezz'
        };
        this.boundOnAdded = this.onCartAdded.bind(this);
        this.boundOnKeyDown = this.onKeyDown.bind(this);
        this.panel = this.querySelector('.godu-cart-drawer__panel');
        this.itemTemplate = this.querySelector('[data-cart-drawer-item-template]');
        this.crosssellTemplate = this.querySelector('[data-cart-drawer-crosssell-template]');
        this.itemsEl = this.querySelector('[data-cart-drawer-items]');
        this.emptyEl = this.querySelector('[data-cart-drawer-empty]');
        this.shippingEl = this.querySelector('[data-cart-drawer-shipping]');
        this.shippingFill = this.querySelector('[data-cart-drawer-shipping-fill]');
        this.shippingText = this.querySelector('[data-cart-drawer-shipping-text]');
        this.crosssellEl = this.querySelector('[data-cart-drawer-crosssell]');
        this.footerEl = this.querySelector('[data-cart-drawer-footer]');
        this.countEl = this.querySelector('[data-cart-drawer-count]');
        this.subtotalEl = this.querySelector('[data-cart-drawer-subtotal]');
      }

      connectedCallback() {
        this.bindEvents();
        document.addEventListener('godu:cart:add', this.boundOnAdded);
      }

      disconnectedCallback() {
        document.removeEventListener('godu:cart:add', this.boundOnAdded);
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      bindEvents() {
        // Close triggers
        this.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
          el.addEventListener('click', this.close.bind(this));
        }.bind(this));
      }

      onCartAdded() {
        if (getCartMode() !== 'b2c_drawer') return;
        this.refresh().then(this.open.bind(this));
      }

      onKeyDown(e) {
        if (e.key === 'Escape') this.close();
      }

      open() {
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.boundOnKeyDown);
      }

      close() {
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      refresh() {
        var self = this;
        return fetchCart().then(function (cart) {
          self.render(cart);
          updateCartBadges(cart.item_count);
          return cart;
        });
      }

      render(cart) {
        if (!cart) return;
        this.countEl.textContent = cart.item_count;

        if (cart.item_count === 0) {
          this.emptyEl.hidden = false;
          this.itemsEl.hidden = true;
          this.itemsEl.innerHTML = '';
          this.shippingEl.hidden = true;
          this.crosssellEl.hidden = true;
          this.crosssellEl.innerHTML = '';
          this.footerEl.hidden = true;
          return;
        }

        this.emptyEl.hidden = true;
        this.itemsEl.hidden = false;
        this.footerEl.hidden = false;

        this.renderItems(cart.items);
        this.renderShipping(cart);
        this.loadItemData(cart);

        this.subtotalEl.textContent = money(cart.items_subtotal_price || cart.total_price);
      }

      renderItems(items) {
        this.itemsEl.innerHTML = '';
        items.forEach(function (item, idx) {
          var node = this.itemTemplate.content.cloneNode(true);
          var li = node.querySelector('li');
          li.setAttribute('data-line-key', item.key || (idx + 1));

          var img = node.querySelector('[data-item-image]');
          if (item.image) {
            img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2');
            img.alt = item.title || item.product_title || '';
          }

          node.querySelectorAll('[data-item-link]').forEach(function (a) {
            a.href = item.url;
          });
          var titleEl = node.querySelector('.godu-cart-drawer__item-title');
          titleEl.textContent = item.product_title || item.title;

          // Pre-order: de regel-eigenschap uit snippets/preorder.liquid (naam = preorder.property_name)
          var preorderValue = item.properties && item.properties['Pre-order'];
          if (preorderValue) {
            var pill = document.createElement('span');
            pill.className = 'godu-preorder-pill';
            pill.textContent = 'Pre-order · ' + preorderValue;
            titleEl.insertAdjacentElement('afterend', pill);
          }

          var variantEl = node.querySelector('[data-item-variant]');
          if (item.variant_title && item.variant_title !== 'Default Title') {
            variantEl.textContent = item.variant_title;
          } else {
            variantEl.remove();
          }

          node.querySelector('[data-item-price]').textContent = money(item.final_line_price);

          var qtyInput = node.querySelector('[data-qty-input]');
          qtyInput.value = item.quantity;

          var lineKey = item.key || (idx + 1);

          var self = this;
          var debouncedUpdate = debounce(function (q) {
            self.changeQty(lineKey, q);
          }, 350);

          qtyInput.addEventListener('change', function () {
            debouncedUpdate(parseInt(qtyInput.value, 10) || 0);
          });
          qtyInput.addEventListener('input', function () {
            debouncedUpdate(parseInt(qtyInput.value, 10) || 0);
          });

          node.querySelector('[data-qty-decrease]').addEventListener('click', function () {
            var v = (parseInt(qtyInput.value, 10) || 1) - 1;
            qtyInput.value = Math.max(0, v);
            debouncedUpdate(Math.max(0, v));
          });
          node.querySelector('[data-qty-increase]').addEventListener('click', function () {
            var v = (parseInt(qtyInput.value, 10) || 0) + 1;
            qtyInput.value = v;
            debouncedUpdate(v);
          });
          node.querySelector('[data-qty-remove]').addEventListener('click', function () {
            self.changeQty(lineKey, 0);
          });

          this.itemsEl.appendChild(node);
        }, this);
      }

      changeQty(lineKey, quantity) {
        var self = this;
        return updateCartItem(lineKey, quantity).then(function () {
          self.refresh();
        });
      }

      // Adezz-dominante verzendberekening, gespiegeld aan main-cart.liquid.
      renderShipping(cart) {
        var c = this.cfg, goduSub = 0, adezzSub = 0;
        (cart.items || []).forEach(function (it) {
          if (it.vendor === c.adezzVendor) adezzSub += it.final_line_price;
          else goduSub += it.final_line_price;
        });
        var threshold, subtotal;
        if (adezzSub > 0) { threshold = c.adezzThresholdCents; subtotal = adezzSub; }
        else if (goduSub > 0) { threshold = c.goduThresholdCents; subtotal = goduSub; }
        else { this.shippingEl.hidden = true; return; }

        var remaining = threshold - subtotal;
        if (remaining <= 0) {
          this.shippingEl.classList.add('godu-cart-drawer__shipping--reached');
          this.shippingFill.style.width = '100%';
          this.shippingText.textContent = 'Gratis bezorging, geregeld';
        } else {
          this.shippingEl.classList.remove('godu-cart-drawer__shipping--reached');
          var pct = Math.max(4, Math.min(100, Math.round((subtotal / threshold) * 100)));
          this.shippingFill.style.width = pct + '%';
          this.shippingText.textContent = 'Nog ' + money(remaining) + ' tot gratis verzending';
        }
        this.shippingEl.hidden = false;
      }

      // Haalt per cart-product de headless data op (levertijd + cross-sell) en:
      //  1. vult de levertijd-indicatie per item-rij
      //  2. rendert de cross-sell (gecureerd custom.cross_selling, dedupe, max 2,
      //     producten die al in de cart zitten worden overgeslagen)
      loadItemData(cart) {
        this.crosssellEl.innerHTML = '';
        this.crosssellEl.hidden = true;
        if (!cart.items || cart.items.length === 0) return;

        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });

        var self = this;
        var fetchData = function (handle) {
          return fetch('/products/' + handle + '?section_id=cart-crosssell-data', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : null; })
            .then(function (html) {
              if (!html) return null;
              try {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var el = doc.getElementById('godu-crosssell-data');
                return el ? JSON.parse(el.textContent) : null;
              } catch (e) { return null; }
            })
            .catch(function () { return null; });
        };
        // resultaten in dezelfde volgorde als cart.items (en dus als de item-rijen)
        var fetches = cart.items.map(function (item) { return fetchData(item.handle); });

        Promise.all(fetches).then(function (results) {
          // 1. Voorraadstatus per item-rij (zoals product.liquid: Op voorraad! enz.)
          var rows = self.itemsEl.querySelectorAll('.godu-cart-drawer__item');
          var check = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#00930a" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';
          results.forEach(function (data, idx) {
            var row = rows[idx];
            if (!row) return;
            var stockEl = row.querySelector('[data-item-stock]');
            if (!stockEl) return;
            // Pre-orderregel: de pil zegt al wanneer hij komt, geen 'Binnenkort op voorraad' eronder
            if (row.querySelector('.godu-preorder-pill')) { stockEl.hidden = true; return; }
            var item = cart.items[idx];
            var stock = data && data.stock && item ? data.stock[item.variant_id] : null;
            if (stock && stock.label) {
              stockEl.classList.toggle('godu-cart-drawer__item-stock--out', !stock.in);
              stockEl.innerHTML = (stock.in ? check : '') + '<span></span>';
              stockEl.querySelector('span').textContent = stock.label;
              stockEl.hidden = false;
            } else {
              stockEl.hidden = true;
            }
          });

          // 2. Cross-sell verzamelen + dedupe
          var seen = {};
          var picks = [];
          results.forEach(function (data) {
            var list = (data && data.crosssell) || [];
            list.forEach(function (p) {
              if (!p || inCart[p.id] || seen[p.id]) return;
              seen[p.id] = true;
              picks.push(p);
            });
          });

          var toRender = picks.slice(0, 2);
          if (toRender.length === 0) return;
          var totalCartQty = cart.items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);

          var wrap = document.createElement('div');
          wrap.className = 'godu-cart-drawer__crosssell-wrap';
          wrap.innerHTML =
            '<div class="godu-cart-drawer__crosssell-header">' +
              '<span class="godu-cart-drawer__crosssell-header-line"></span>' +
              '<span class="godu-cart-drawer__crosssell-header-text">VERGEET NIET</span>' +
              '<span class="godu-cart-drawer__crosssell-header-line"></span>' +
            '</div>';
          self.crosssellEl.appendChild(wrap);

          toRender.forEach(function (p) { self.renderCrossSellCard(p, wrap, totalCartQty); });
          self.crosssellEl.hidden = false;
        });
      }

      renderCrossSellCard(product, wrap, cartQty) {
        var node = this.crosssellTemplate.content.cloneNode(true);
        var firstVariant = product.variants && product.variants[0];
        if (!firstVariant) return;

        var img = node.querySelector('[data-cs-image]');
        var imgWrap = node.querySelector('[data-cs-image-wrap]');
        if (product.featured_image) {
          img.src = product.featured_image;
          img.alt = product.title;
        } else {
          imgWrap.remove();
        }

        node.querySelector('[data-cs-title]').textContent = product.title;

        // Resolution order:
        //   1. Dynamisch uit tags: 1-regel subtitle + aanbevolen quantity (drijft pill-prijs)
        //   2. Statische metafield custom.cross_sell_subtitle: alleen subtitle, qty = 1
        //   3. Geen subtitle, qty = 1
        var subtitleEl = node.querySelector('[data-cs-subtitle]');
        var addQty = 1;
        var conf = parseCrossSellTags(product);
        if (conf && cartQty && cartQty > 0) {
          var parts = buildCrossSellSubtitle(conf, cartQty);
          subtitleEl.innerHTML = parts.text;
          subtitleEl.hidden = false;
          addQty = parts.quantity;
        } else {
          var fallback = product.cross_sell_subtitle ||
            (product.metafields && product.metafields.custom && product.metafields.custom.cross_sell_subtitle);
          if (fallback) {
            subtitleEl.innerHTML = fallback;
            subtitleEl.hidden = false;
          }
        }

        var btn = node.querySelector('[data-cs-add]');
        var label = node.querySelector('[data-cs-add-label]');
        btn.setAttribute('data-cs-variant-id', firstVariant.id);
        btn.setAttribute('data-cs-quantity', addQty);
        var totalPrice = firstVariant.price * addQty;
        label.textContent = '+ ' + money(totalPrice);

        var self = this;
        btn.addEventListener('click', function () {
          btn.disabled = true;
          label.textContent = 'Toevoegen…';
          addToCart([{ id: firstVariant.id, quantity: addQty }]).then(function () {
            self.refresh();
          }).catch(function () {
            btn.disabled = false;
            label.textContent = '+ ' + money(totalPrice);
          });
        });

        (wrap || this.crosssellEl).appendChild(node);
      }
    }

    customElements.define('godu-cart-drawer', CartDrawer);
  }

  // ============================================================
  // Cart Toast (B2B)
  // ============================================================

  // Pak het eerste line-item uit een /cart/add.js response (single OF wrapped {items: [...]}).
  function firstAddedItem(response) {
    if (!response) return {};
    if (response.items && response.items.length) return response.items[0];
    if (response.id) return response;
    return {};
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }


  if (!customElements.get('cart-toast-adeqo')) {
    class CartToast extends HTMLElement {
      constructor() {
        super();
        this.boundOnAdded = this.onCartAdded.bind(this);
        this.boundOnKeyDown = this.onKeyDown.bind(this);
        this.statusEl = this.querySelector('[data-toast-status]');
        this.titleEl = this.querySelector('[data-toast-title]');
        this.subtitleEl = this.querySelector('[data-toast-subtitle]');
        this.crosssellEl = this.querySelector('[data-modal-crosssell]');

        // Eenheid labels uit section settings (default panelen/paneel)
        this.unitSingular = this.dataset.unitSingular || 'paneel';
        this.unitPlural = this.dataset.unitPlural || 'panelen';
      }

      connectedCallback() {
        document.addEventListener('godu:cart:add', this.boundOnAdded);
        this.querySelectorAll('[data-toast-dismiss]').forEach(function (el) {
          el.addEventListener('click', this.hide.bind(this));
        }.bind(this));
      }

      disconnectedCallback() {
        document.removeEventListener('godu:cart:add', this.boundOnAdded);
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      onCartAdded(e) {
        if (getCartMode() !== 'b2b_toast') return;

        var detail = (e && e.detail) || {};
        // Snelbestellen (B2B-portal) is een bulk-besteltool met eigen inline-
        // feedback + cart-badge. Geen onderbrekende modal/cross-sell daar.
        if (detail.source === 'b2b-quickorder') return;

        var requested = (detail.requested && detail.requested[0]) || {};
        var added = firstAddedItem(detail.response);

        // Refresh cart-state om totalen te tonen
        var self = this;
        fetchCart().then(function (cart) {
          updateCartBadges(cart.item_count);
          self.renderTitle(added, requested);
          self.renderStatus(cart);
          self.renderCrossSell(cart);
          self.show();
        });
      }

      // Title = qty × volle product_title. Subtitle = variant_title alleen als
      // het zinvol is (niet 'Default Title' bij Adeqo's flat-product structuur).
      renderTitle(added, requested) {
        var name = added.product_title || added.title || requested.product_title || 'Product';
        var qty = added.quantity || requested.quantity || 1;
        this.titleEl.textContent = '✓ ' + qty + '× ' + name;

        var variant = added.variant_title || '';
        if (variant && variant !== 'Default Title') {
          this.subtitleEl.textContent = variant;
          this.subtitleEl.hidden = false;
        } else {
          this.subtitleEl.hidden = true;
        }
      }

      // Status: totaal items. GEEN prijs (BSS rewrited alleen op /cart pagina).
      // Eenheid 'panelen' alleen als ALLE cart-items panels zijn — anders 'items'
      // (mixed cart met montagekit/eindlat/sample). Adeqo products hebben leeg
      // product_type dus detectie gaat via product_title pattern "akoestische (wand)panelen".
      renderStatus(cart) {
        var allPanels = (cart.items || []).length > 0 && cart.items.every(function (i) {
          var t = (i.product_title || i.title || '').toLowerCase();
          return /akoestische\s+(wand)?panelen/.test(t);
        });
        var label;
        if (allPanels) {
          label = cart.item_count === 1 ? this.unitSingular : this.unitPlural;
        } else {
          label = cart.item_count === 1 ? 'item' : 'items';
        }
        this.statusEl.textContent = 'Winkelwagen: ' + cart.item_count + ' ' + label;
      }

      // Cross-sell: pak eerste complementary recommendation die NIET in cart zit.
      // Prominente variant — green-soft card met "VERGEET NIET" label en X-aanbevolen subtitle.
      renderCrossSell(cart) {
        if (!this.crosssellEl) return;
        this.crosssellEl.innerHTML = '';
        this.crosssellEl.hidden = true;

        if (!cart.items || cart.items.length === 0) return;

        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });

        var self = this;
        var fetches = cart.items.map(function (item) {
          return fetch('/recommendations/products.json?product_id=' + item.product_id + '&intent=complementary&limit=4', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        });

        Promise.all(fetches).then(function (results) {
          var seen = {};
          var pick = null;
          results.some(function (data) {
            if (!data || !data.products) return false;
            return data.products.some(function (p) {
              if (inCart[p.id] || seen[p.id]) return false;
              seen[p.id] = true;
              pick = p;
              return true;
            });
          });
          if (!pick) return;

          var totalCartQty = cart.items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
          self.renderCrossSellCard(pick, totalCartQty);
          self.crosssellEl.hidden = false;
        });
      }

      renderCrossSellCard(product, cartQty) {
        var firstVariant = product.variants && product.variants[0];
        if (!firstVariant) return;

        var addQty = 1;
        var subtitleHTML = '';
        var unitLabel = '';
        var conf = parseCrossSellTags(product);
        if (conf && cartQty > 0) {
          var parts = buildCrossSellSubtitle(conf, cartQty);
          subtitleHTML = parts.text;
          addQty = parts.quantity;
          unitLabel = addQty === 1 ? conf.unit : conf.unit_plural;
        } else if (product.cross_sell_subtitle) {
          subtitleHTML = product.cross_sell_subtitle;
        }

        // Button-label: GEEN prijs (BSS B2B rewrited prijzen alleen op /cart pagina —
        // Shopify variant.price is base prijs zonder staffel/BE BTW-vrijstelling).
        // Toon ipv prijs het aantal+eenheid zodat user weet wat ze toevoegen.
        var btnLabel = unitLabel
          ? '+ Voeg ' + addQty + ' ' + unitLabel + ' toe'
          : '+ Voeg toe';

        var imageHTML = product.featured_image
          ? '<img class="adeqo-cart-modal__cs-image" src="' + escapeHTML(product.featured_image) + '" alt="' + escapeHTML(product.title) + '" width="56" height="56" loading="lazy">'
          : '';
        var subtitleEl = subtitleHTML
          ? '<div class="adeqo-cart-modal__cs-subtitle">' + subtitleHTML + '</div>'
          : '';

        var card = document.createElement('div');
        card.className = 'adeqo-cart-modal__cs-card';
        card.innerHTML =
          '<div class="adeqo-cart-modal__cs-label">VERGEET NIET</div>' +
          imageHTML +
          '<div class="adeqo-cart-modal__cs-info">' +
            '<div class="adeqo-cart-modal__cs-title">' + escapeHTML(product.title) + '</div>' +
            subtitleEl +
          '</div>' +
          '<button type="button" class="adeqo-cart-modal__cs-add">' + escapeHTML(btnLabel) + '</button>';

        var self = this;
        var btn = card.querySelector('.adeqo-cart-modal__cs-add');
        btn.addEventListener('click', function () {
          btn.disabled = true;
          var origText = btn.textContent;
          btn.textContent = 'Toevoegen…';
          addToCart([{ id: firstVariant.id, quantity: addQty }]).then(function () {
            // Refresh modal-content na succesvolle add
            fetchCart().then(function (c) {
              updateCartBadges(c.item_count);
              self.renderStatus(c);
              self.renderCrossSell(c);
            });
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = origText;
          });
        });

        this.crosssellEl.appendChild(card);
      }

      show() {
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.boundOnKeyDown);

        // Focus default op "Doorgaan met winkelen" (workflow respect — user kan direct
        // doortikken met Enter zonder per ongeluk naar cart te gaan)
        var dismissBtn = this.querySelector('.adeqo-cart-modal__btn--secondary');
        if (dismissBtn) {
          setTimeout(function () { dismissBtn.focus({ preventScroll: true }); }, 200);
        }
      }

      hide() {
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      onKeyDown(e) {
        if (e.key === 'Escape') this.hide();
      }
    }

    customElements.define('cart-toast-adeqo', CartToast);
  }

  // ============================================================
  // Cart-knop intercept — open de drawer i.p.v. de oude .mini-cart dropdown.
  // Capture-phase + stopImmediatePropagation neutraliseert de oude handler in custom.js
  // zonder die te hoeven aanpassen.
  // ============================================================

  function bindCartIconClicks() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-smallcart');
      if (!btn) return;
      var drawer = document.querySelector('godu-cart-drawer');
      if (!drawer) return; // val terug op oude gedrag als drawer ontbreekt
      e.preventDefault();
      e.stopImmediatePropagation();
      drawer.refresh().then(function () { drawer.open(); });
    }, true);
  }

  // ============================================================
  // Init
  // ============================================================

  function init() {
    injectPulseStyles();
    bindCartIconClicks();

    // Pulse cart icon on every successful add
    document.addEventListener('godu:cart:add', function () {
      pulseCartIcon();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
